import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMemo, useState } from 'react';
import { Header } from 'datastake-daf/dist/components';
import { useLocation, useNavigate } from 'react-router-dom';
import Base from './components/Base';
import Loading from '../../../../../components/Loading';
import Styles from '../../../../../components/Forms/locations/style';
import { renderBreadCrumbs } from '../../../../../helpers/breadCrumbs';

export default function TAZAMAPartners() {
  const goTo = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [activeTab, setActiveTab] = useState(params.get('tab') || 'partners');
  const [loading, setLoading] = useState(true);
  const [createVisible, setCreateVisible] = useState(params.has('create'));
  const [totalRequests, setTotalRequests] = useState();
  const [requestDataFetch, setRequestDataFetch] = useState(false)

  const items = useMemo(() => [
    {
      label: (
        <div className="tab-cont">
          <div className="flex flex-column justify-content-center">
            {t('List')}
          </div>
        </div>
      ),
      key: 'partners',
    },
    {
      label: (
        <div className="tab-cont">
          <div className="flex flex-column justify-content-center">
            {t('Requests')}
          </div>
          {typeof totalRequests === 'number' ? (
            <div className="flex flex-column justify-content-center">
              <div className="bubble">
                <div className="flex flex-column justify-content-center">
                  {totalRequests}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      ),
      key: 'requests'
    },
  ], [t, totalRequests]);

  const breadCrumbs = useMemo(() =>
    renderBreadCrumbs({ view: 'partners', t, goTo, mod: module }), [t, goTo]);

  return (
    <Styles className="semibold form-input-output">
      <Header
        title={t('Partners')}
        breadcrumbs={breadCrumbs}
        tooltip={{
          title: t('Partners'),
          content: (
            <div className="max-w-250">
              {t("Partners are organisations sharing their information with you, or receiving your information.")}
              <br />
              {t('Only authorised users can create partnerships.')}
            </div>
          ),
        }}
        actionButtons={[
          {
            type: 'primary',
            onClick: () => setCreateVisible(true),
            label: t("New"),
          },
        ]}
      />

      <Tabs
        items={items}
        defaultActiveKey={activeTab}
        onChange={(val) => setActiveTab(val)}
        className="view-page-tabs mt-3"
      />

      {/* <Base
          loading={loading}
          activeTab={activeTab}
          setLoading={setLoading}
          createVisible={createVisible}
          setCreateVisible={setCreateVisible}
        /> */}

      <div
        className="column start table-content"
        style={{ display: activeTab === 'partners' ? 'block' : 'none' }}>
        <Base
          loading={loading}
          activeTab={items[0].key}
          setLoading={setLoading}
          createVisible={createVisible}
          requestDataFetch={requestDataFetch}
          setRequestDataFetch={setRequestDataFetch}
          setCreateVisible={setCreateVisible}
        />
      </div>

      <div
        className="column start table-content"
        style={{ display: activeTab === 'requests' ? 'block' : 'none' }}>
        <Base
          loading={loading}
          activeTab={items[1].key}
          setLoading={setLoading}
          createVisible={createVisible}
          setCreateVisible={setCreateVisible}
          setTotalRequests={setTotalRequests}
          requestDataFetch={requestDataFetch}
          setRequestDataFetch={setRequestDataFetch}
        />
      </div>
    </Styles >
  );
}
